import homeReducer from "./reducer";

export default homeReducer;
